import { FunctionComponent, h } from "preact"
import { Role, RoleList } from "../../../enum/roles.enum"

import { AxiosApiError } from "../../../types/api-response"
import { Button } from "../../../parts/buttons"
import { mutate } from "swr"
import useAllCompany from "../../../hooks/useAllCompany"
import useAuth from "../../../hooks/useAuth"
import useObjectState from "../../../hooks/useObjectState"
import useUsers from "../../../hooks/useUsers"
import Renderif from "../../../components/Renderif";


type NewUserProps = h.JSX.HTMLAttributes<HTMLDivElement> & {
  show: boolean
  onHide: () => void
}

const NewUser: FunctionComponent<NewUserProps> = ({ show, onHide }) => {
  const { data: companies } = useAllCompany()
  const defaultState = {
    name: "",
    email: "",
    password: "",
    role: Role.Operator,
    tag_mills: false,
    company: { uuid: "" },
    mil: { uuid: "" },
    notification: false,
    notification_interval: 6,
  }
  const [user, setUser] = useObjectState(defaultState)
  const { fetcher } = useAuth()

  const handleErrorResponse = (e: AxiosApiError) => {
    const msg = e.response?.data?.data?.message || e.response?.data?.message || "Server Error"
    if (alert) {
      if (Array.isArray(msg)) alert(msg.map((t) => "- " + t).join("\n"))
      else alert(msg)
    }
  }

  const handleSubmit = () => {
    const formData: any = {
      name: user.name,
      email: user.email,
      password: user.password,
      role: user.role,
      tag_mills: false,
      company: user.company,
      mil: user.mil,
      notification: user.notification,
      notification_interval: user.notification_interval
    };

    let data = user
    if (data.role == Role.Admin && data.company.uuid == "") {
      const { name, email, password, role, tag_mills, notification, notification_interval } = data
      fetcher()
        .post("/auth/sign-up", { name, email, password, role, tag_mills, notification, notification_interval })
        .then((res) => {
          if (onHide) onHide()
          setUser(defaultState)
          mutate("/user")
          return res.data
        })
        .then((res) => {
          if (!res?.data?.access_token) return
          const me = JSON.parse(atob(res?.data?.access_token?.split(".")[1])).uuid
          if (!me) return
          fetcher()
            .patch("/user/" + me, {
              notification: user.notification,
              notification_interval: user.notification_interval,
            })
            .then(() => {
              mutate("/user")
            })
            .catch(console.log)
        })
        .catch(handleErrorResponse)
    } else{
      if (user.mil.uuid === "") {
        formData.mil = null;
      }
      fetcher()
        .post("/user", formData)
        .then(() => {
          if (onHide) onHide()
          setUser(defaultState)
          mutate("/user")
        })
        .catch(handleErrorResponse)
    }
      
  }
  const handleCancel = () => {
    setUser(defaultState)
    if (onHide) onHide()
  }
  // console.log(user.notification)
  // console.log(user.tag_mills)
  return (
    <div
      className="modal-backdrop"
      style={{
        display: show ? "inherit" : "none",
        backgroundColor: "#00000099",
        overflowY: "auto",
      }}
    >
      <div class="modal-dialog modal-lg modal-dialog-centered " role="document">
        <div class="modal-content card">
          <div className="card-body d-flex justify-content-between">
            <h5 class="card-title">Add New User</h5>
            <div>
              <Button variant="primary" onClick={handleSubmit}>
                Add User
              </Button>
              <Button variant="tertiary" className="ms-2" onClick={handleCancel}>
                Cancel
              </Button>
            </div>
          </div>
          <div className="card-body px-4">
            <div class="form-group pb-2">
              <label>Name</label>
              <input
                value={user.name}
                required
                type="text"
                class="form-control"
                onChange={({ currentTarget }) => {
                  setUser({ name: currentTarget.value })
                }}
              />
            </div>
            <div class="form-group pb-2 ">
              <label>Email</label>
              <input
                value={user.email}
                required
                type="email"
                class="form-control"
                onChange={({ currentTarget }) => {
                  setUser({ email: currentTarget.value })
                }}
              />
            </div>
            <div class="form-group pb-2 ">
              <label>Password</label>
              <input
                value={user.password}
                required
                type="string"
                class="form-control"
                onChange={({ currentTarget }) => {
                  setUser({ password: currentTarget.value })
                }}
              />
            </div>
            <div class="form-group pb-2">
              <label>Role</label>
              <select
                name=""
                value={user.role}
                className="rounded-pill form-control"
                onChange={({ currentTarget }) => {
                  setUser({ role: currentTarget.value as Role })
                }}
                id=""
              >
                {RoleList.map((role) => (
                  <option key={role} value={role}>
                    {role}
                  </option>
                ))}
              </select>
            </div>
            <div class="form-group pb-2">
              <label>Affiliate</label>
              <select
                name=""
                className="rounded-pill form-control"
                value={user.company.uuid}
                id=""
                onChange={({ currentTarget }) => {
                  setUser({ company: { uuid: currentTarget.value } })
                }}
              >
                {user.role == Role.Admin && <option value="">HQ</option>}
                {companies?.map(({ uuid, name }) => (
                  <option key={uuid} value={uuid}>
                    {name}
                  </option>
                ))}
              </select>
            </div>
            {/* {user.company.uuid && (
              <div class="form-group pb-2">
                <label>Mills</label>
                <select
                  name=""
                  className="rounded-pill form-control"
                  value={user.mil.uuid}
                  id=""
                  onChange={({ currentTarget }) => {
                    setUser({ mil: { uuid: currentTarget.value } })
                  }}
                >
                  {user.role==Role.Manager || user.role==Role.HeadDiv || user.role==Role.SustainabilityDiv ? <option value={companies?.find(({ uuid }) => uuid == user.company.uuid)
                    ?.mils[0].uuid}>All Mills</option>: companies
                    ?.find(({ uuid }) => uuid == user.company.uuid)
                    ?.mils?.map(({ uuid, name }) => (
                      <option key={uuid} value={uuid}>
                        {name}
                      </option>
                    // }
                    ))}
                </select>
              </div>
            )} */}
            {user.company.uuid && (
              <div class="form-group pb-2">
                <label>Mills</label>
                <select
                  name=""
                  className="rounded-pill form-control"
                  value={user.mil.uuid}
                  id=""
                  onChange={({ currentTarget }) => {
                    setUser({ mil: { uuid: currentTarget.value } });
                  }}
                >
                  <Renderif isTrue={user.role !== Role.Member && user.role !== Role.Operator}>
                    <option value="">All Mills</option>
                  </Renderif>
                  {companies
                    ?.find(({ uuid }) => uuid == user.company.uuid)
                    ?.mils?.map(({ uuid, name }) => (
                      <option key={uuid} value={uuid}>
                        {name}
                      </option>
                    ))}
                </select>
              </div>
            )}
            <div class="form-group pb-2">
              <label>Notification</label>
              <select
                name=""
                className="rounded-pill form-control"
                value={user.notification ? "on" : "off"}
                id=""
                onChange={({ currentTarget }) => {
                  setUser({ notification: currentTarget.value == "on" })
                }}
              >
                <option value="on">On</option>
                <option value="off">Off</option>
              </select>
            </div>
            <div class="form-group pb-2 ">
              <label>Email Notification Interval</label>
              <input value={user.notification_interval + " Hours"} required type="text" disabled class="form-control" />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NewUser
